import React from 'react';
import Icon from '@ant-design/icons';

const DashboardSvg2 = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
    <path
      d="M30.544,36a4.635,4.635,0,0,1,.76,2.55,4.746,4.746,0,1,1-2.17-3.97l-1.61,1.61a2.477,2.477,0,0,0-.95-.19,2.555,2.555,0,1,0,2.55,2.55,2.763,2.763,0,0,0-.18-.95Zm6.03,2.55a10,10,0,1,1-10-10A10,10,0,0,1,36.574,38.551Zm-2.77,0a7.23,7.23,0,1,0-7.23,7.23A7.234,7.234,0,0,0,33.8,38.551Z"
      transform="translate(-16.574 -28.551)"
    />
  </svg>
);

const OverviewIconSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
    <path
      id="Path_21455"
      data-name="Path 21455"
      d="M398,976.05a2,2,0,1,0-2-2,2,2,0,0,0,2,2Zm0-6a2,2,0,1,0-2-2,2,2,0,0,0,2,2Zm0-6a2,2,0,1,0-2-2,2,2,0,0,0,2,2Zm-6,12a2,2,0,1,0-2-2,2,2,0,0,0,2,2Zm0-6a2,2,0,1,0-2-2,2,2,0,0,0,2,2Zm0-6a2,2,0,1,0-2-2,2,2,0,0,0,2,2Zm-6,12a2,2,0,1,0-2-2,2,2,0,0,0,2,2Zm0-6a2,2,0,1,0-2-2,2,2,0,0,0,2,2Zm0-6a2,2,0,1,0-2-2,2,2,0,0,0,2,2Z"
      transform="translate(-384 -960.05)"
    />
  </svg>
);

const ApplicationsSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16.002"
    height="16.001"
    viewBox="0 0 16.002 16.001"
    fill="currentColor"
  >
    <path
      id="Path_21442"
      data-name="Path 21442"
      d="M271.091,709.307l-.437.436-4.4-4.393.438-.438a3.108,3.108,0,0,1,4.4,4.394h0Zm-1.85,1.85-2.917,2.916-3.934,3.933a4.449,4.449,0,0,1-1.74.985l-3.846.96a.568.568,0,0,1-.636-.118.574.574,0,0,1-.12-.636l.962-3.843a4.395,4.395,0,0,1,.985-1.74l3.936-3.936,2.917-2.916,4.394,4.393v0Z"
      transform="translate(-256 -704)"
    />
  </svg>
);

const ReportsSvg = () => (
  <svg
    id="Group_19868"
    data-name="Group 19868"
    xmlns="http://www.w3.org/2000/svg"
    width="16.163"
    height="16"
    viewBox="0 0 16.163 16"
    fill="currentColor"
  >
    <path
      id="Path_21441"
      data-name="Path 21441"
      d="M.577,0H4.041a.574.574,0,0,1,.577.571V6.286a.574.574,0,0,1-.577.571H.577A.574.574,0,0,1,0,6.286V.571A.574.574,0,0,1,.577,0Z"
      transform="translate(0 9.143)"
    />
    <path
      id="Path_21439"
      data-name="Path 21439"
      d="M.577,0H4.041a.574.574,0,0,1,.577.571V10.857a.574.574,0,0,1-.577.571H.577A.574.574,0,0,1,0,10.857V.571A.574.574,0,0,1,.577,0Z"
      transform="translate(11.545 4.571)"
    />
    <path
      id="Path_21440"
      data-name="Path 21440"
      d="M.577,0H4.041a.574.574,0,0,1,.577.571V15.429A.574.574,0,0,1,4.041,16H.577A.574.574,0,0,1,0,15.429V.571A.574.574,0,0,1,.577,0Z"
      transform="translate(5.773)"
    />
  </svg>
);

const SettingsSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16.003"
    height="16.004"
    viewBox="0 0 16.003 16.004"
    fill="currentColor"
  >
    <path
      id="Path_21453"
      data-name="Path 21453"
      d="M207.961,330.177l-.793,1.91a.509.509,0,0,1-.665.278l-.9-.373a1.241,1.241,0,0,0-1.61,1.61l.374.9a.505.505,0,0,1-.276.666l-1.91.794a.508.508,0,0,1-.665-.276l-.374-.9a1.243,1.243,0,0,0-2.28,0l-.373.9a.506.506,0,0,1-.666.276l-1.91-.79a.511.511,0,0,1-.277-.666l.373-.9A1.241,1.241,0,0,0,194.4,332l-.9.373a.5.5,0,0,1-.665-.277l-.79-1.914a.511.511,0,0,1,.276-.667l.9-.374a1.238,1.238,0,0,0,0-2.273l-.9-.375a.506.506,0,0,1-.276-.666l.793-1.91a.511.511,0,0,1,.665-.28l.9.373a1.241,1.241,0,0,0,1.61-1.61l-.372-.9a.505.505,0,0,1,.276-.666l1.91-.79a.508.508,0,0,1,.665.276l.374.9a1.243,1.243,0,0,0,2.28,0l.373-.9a.506.506,0,0,1,.666-.276l1.91.79a.511.511,0,0,1,.277.666l-.37.895a1.24,1.24,0,0,0,1.613,1.614l.9-.37a.5.5,0,0,1,.665.276l.79,1.914a.511.511,0,0,1-.276.667l-.9.374a1.238,1.238,0,0,0,0,2.273l.9.373a.506.506,0,0,1,.276.666ZM200,324a4,4,0,1,0,2.828,1.172A4,4,0,0,0,200,324Zm0,6a2,2,0,1,1,1.414-.586A2,2,0,0,1,200,330Z"
      transform="translate(-192 -320)"
    />
  </svg>
);

const BellSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="41.675" height="50" viewBox="0 0 41.675 50" fill="currentColor">
    <path
      id="Path_28325"
      data-name="Path 28325"
      d="M91.358,64.122a3.649,3.649,0,0,1-3.65,3.625H53.333a3.635,3.635,0,0,1-2.375-6.4,13.952,13.952,0,0,0,4.975-10.7v-5.8a12.213,12.213,0,0,1,.075-1.35c.025-.35.075-.675.125-1a9.28,9.28,0,0,1,.375-1.65,11.251,11.251,0,0,1,.4-1.2c.125-.35.3-.725.45-1.075l.075-.15c.2-.375.4-.725.6-1.075.2-.325.4-.625.6-.925a.947.947,0,0,1,.25-.325c.2-.275.425-.55.65-.825.275-.325.575-.625.875-.925a13.656,13.656,0,0,1,4.25-2.85,11.993,11.993,0,0,1,2.475-.825c.425-.1.85-.175,1.3-.25a11.906,11.906,0,0,1,2.1-.175,11.435,11.435,0,0,1,2.075.175A12.858,12.858,0,0,1,76.383,31.5c.4.175.775.375,1.15.575A10.534,10.534,0,0,1,79.658,33.5c.35.275.65.55.975.85.3.3.6.6.875.925.225.275.45.55.65.825a.948.948,0,0,1,.25.325,7.3,7.3,0,0,1,.6.925,9.057,9.057,0,0,1,.6,1.075,4.908,4.908,0,0,1,.4.9,4.386,4.386,0,0,1,.3.8,3.272,3.272,0,0,1,.225.7,13.686,13.686,0,0,1,.5,2.525q.075.75.075,1.5v5.8a13.921,13.921,0,0,0,4.95,10.675A3.715,3.715,0,0,1,91.358,64.122ZM70.521,80.247A7.825,7.825,0,0,0,78.175,74H62.866A7.825,7.825,0,0,0,70.521,80.247Z"
      transform="translate(-49.683 -30.247)"
    />
  </svg>
);

const FacultySVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
    <g id="Faculty_Icon" data-name="Faculty Icon" transform="translate(0)">
      <path
        id="Faculty_Icon-2"
        data-name="Faculty Icon"
        d="M20.331,317.34h-2.5V308.9h2.5Zm4.991-8.437h-2.5v8.437h2.5Zm4.991,0h-2.5v8.437h2.5Zm4.991,0h-2.5v8.437h2.5Zm-8.89-6.533-9.485,3.025a.515.515,0,0,0,.156,1.005h18.97a.515.515,0,0,0,.156-1.005l-9.485-3.025A.519.519,0,0,0,26.414,302.37Zm8.621,17.473H18.105a1.518,1.518,0,0,0-1.517,1.518v.985H36.552v-.985A1.518,1.518,0,0,0,35.035,319.843Z"
        transform="translate(-16.57 -302.346)"
      />
    </g>
  </svg>
);

const FormsSVG = () => (
  <svg
    id="Form_Icon"
    data-name="Form Icon"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="20"
    viewBox="0 0 16 20"
    fill="currentColor"
  >
    <path
      id="Form_Icon-2"
      data-name="Form Icon"
      d="M151.02,270.76v-5c0-.82.48-1.02,1.06-.44l5.88,5.88c.58.58.39,1.06-.44,1.06h-5A1.5,1.5,0,0,1,151.02,270.76Zm6.5,4h-5a4,4,0,0,1-4-4v-5a3.782,3.782,0,0,1,.29-1.5h-4.29a1.5,1.5,0,0,0-1.5,1.5v17a1.5,1.5,0,0,0,1.5,1.5h13a1.5,1.5,0,0,0,1.5-1.5v-8.29A3.785,3.785,0,0,1,157.52,274.76Z"
      transform="translate(-143.02 -264.26)"
    />
  </svg>
);

const LetterSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="14" viewBox="0 0 20 14" fill="currentColor">
    <g id="Letter_Icon" data-name="Letter Icon" transform="translate(0)">
      <path
        id="Letter_Icon-2"
        data-name="Letter Icon"
        d="M129.91,268.76v.42l-10,4.52-10-4.52v-.42a1.5,1.5,0,0,1,1.5-1.5h17A1.5,1.5,0,0,1,129.91,268.76Zm-10,7.57a1.167,1.167,0,0,1-.52-.12l-9.48-4.29v7.84a1.5,1.5,0,0,0,1.5,1.5h17a1.511,1.511,0,0,0,1.5-1.5v-7.84l-9.49,4.29A1.156,1.156,0,0,1,119.91,276.33Z"
        transform="translate(-109.91 -267.26)"
      />
    </g>
  </svg>
);

const ModuleSVG = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20.001"
    height="20.001"
    viewBox="0 0 20.001 20.001"
    fill="currentColor"
  >
    <g id="Module_Icon" data-name="Module Icon" transform="translate(0.001)">
      <path
        id="Module_Icon-2"
        data-name="Module Icon"
        d="M96.784,302.333H95.623a7.646,7.646,0,0,0-6.825,4.436,7.649,7.649,0,0,0-6.826-4.436H80.811a.685.685,0,0,0-.662.706v2.209A23.415,23.415,0,0,1,88.8,307.74a23.517,23.517,0,0,1,8.645-2.49v-2.211a.685.685,0,0,0-.662-.706Zm-9.233,7.921V321.87l-.37-.157c-1.76-.711-1.97-.8-2.55-.8a3.305,3.305,0,0,0-2.491,1.2.528.528,0,0,1-.58.181.693.693,0,0,1-.41-.542l-2.34-12.713a.77.77,0,0,1,.12-.578.549.549,0,0,1,.45-.266A17.255,17.255,0,0,1,87.551,310.254Zm11.232-1.2-2.341,12.713a.7.7,0,0,1-.4.542.523.523,0,0,1-.59-.181,3.253,3.253,0,0,0-2.45-1.2c-.61,0-.77.06-2.641.819l-.31.121v-11.6a17.645,17.645,0,0,1,8.162-2.049.536.536,0,0,1,.45.266A.77.77,0,0,1,98.783,309.049Z"
        transform="translate(-78.797 -302.332)"
      />
    </g>
  </svg>
);

const SearchSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20.001" viewBox="0 0 20 20.001" fill="currentColor">
    <path
      id="Search"
      d="M209.87,83.629a1.235,1.235,0,0,0,1.765,0,1.275,1.275,0,0,0,0-1.788l-3.85-3.85a8.753,8.753,0,1,0-1.775,1.78l3.86,3.858ZM194.5,72.759a6.256,6.256,0,1,1,6.258,6.256,6.256,6.256,0,0,1-6.258-6.256Z"
      transform="translate(-192.001 -64)"
    />
  </svg>
);

const LppaAdminImg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
    <defs>
      <clipPath id="clip-path">
        <rect id="Rectangle_4552" data-name="Rectangle 4552" width="20" height="20" fill="#bebebe" />
      </clipPath>
    </defs>
    <g id="Group_27371" data-name="Group 27371" clip-path="url(#clip-path)">
      <path
        id="Path_30329"
        data-name="Path 30329"
        d="M5,0H1A.99.99,0,0,0,0,1V19a1,1,0,0,0,1,1H5a1,1,0,0,0,1-1V1A1,1,0,0,0,5,0M3,17.01A1.005,1.005,0,1,1,4.01,16,1.007,1.007,0,0,1,3,17.01m1.5-12h-3A.505.505,0,0,1,1.5,4h3a.505.505,0,0,1,0,1.01M4.5,3h-3a.505.505,0,0,1,0-1.01h3A.505.505,0,0,1,4.5,3"
        fill="#bebebe"
        fillRule="evenodd"
      />
      <path
        id="Path_30330"
        data-name="Path 30330"
        d="M12,0H8A1,1,0,0,0,7,1V19a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V1a1,1,0,0,0-1-1M10,17.01A1.005,1.005,0,1,1,11.01,16,1.007,1.007,0,0,1,10,17.01m1.49-12H8.5A.505.505,0,0,1,8.5,4h2.99a.505.505,0,1,1,0,1.01m0-2.01H8.5a.505.505,0,0,1,0-1.01h2.99a.505.505,0,1,1,0,1.01"
        fill="#bebebe"
        fillRule="evenodd"
      />
      <path
        id="Path_30331"
        data-name="Path 30331"
        d="M19,0H15a1,1,0,0,0-1,1V19a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V1a1,1,0,0,0-1-1M17,17.01A1.005,1.005,0,1,1,18.01,16,1.007,1.007,0,0,1,17,17.01m1.5-12h-3A.505.505,0,0,1,15.5,4h3a.505.505,0,0,1,0,1.01M18.5,3h-3a.505.505,0,0,1,0-1.01h3A.505.505,0,0,1,18.5,3"
        fill="#bebebe"
        fillRule="evenodd"
      />
    </g>
  </svg>
);
const LppaImg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
    <defs>
      <clipPath id="clip-path">
        <rect id="Rectangle_4534" data-name="Rectangle 4534" width="20" height="20" fill="#fff" />
      </clipPath>
    </defs>
    <g id="Group_27289" data-name="Group 27289" clip-path="url(#clip-path)">
      <path
        id="Path_30275"
        data-name="Path 30275"
        d="M18,0H2A2.006,2.006,0,0,0,0,2V18a2.006,2.006,0,0,0,2,2H18a2.006,2.006,0,0,0,2-2V2a2.006,2.006,0,0,0-2-2m0,17a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V3A1,1,0,0,1,3,2H17a1,1,0,0,1,1,1Z"
        fill="#fff"
        fillRule="evenodd"
      />
      <rect
        id="Rectangle_4530"
        data-name="Rectangle 4530"
        width="12"
        height="2"
        transform="translate(4.002 5)"
        fill="#fff"
      />
      <rect
        id="Rectangle_4531"
        data-name="Rectangle 4531"
        width="9.998"
        height="2.001"
        transform="translate(4.002 8.992)"
        fill="#fff"
      />
      <rect
        id="Rectangle_4532"
        data-name="Rectangle 4532"
        width="7.994"
        height="2.001"
        transform="translate(4.003 12.999)"
        fill="#fff"
      />
      <rect
        id="Rectangle_4533"
        data-name="Rectangle 4533"
        width="2.001"
        height="2.001"
        transform="translate(13.993 13)"
        fill="#fff"
      />
    </g>
  </svg>
);

const ShortCoursSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="17.129" height="26.169" viewBox="0 0 17.129 26.169">
    <g id="Group_27109" data-name="Group 27109" transform="translate(-872.498 207.121)">
      <path
        id="Union_2"
        data-name="Union 2"
        d="M10.175,25.168a.293.293,0,0,1-.253-.2l-.246-.734-.734.21a.289.289,0,0,1-.3-.1.3.3,0,0,1-.031-.324L9.8,21.7a.47.47,0,0,1-.417-.591l.129-.489.012-.045a.474.474,0,0,0-.157-.488l-.421-.348a.475.475,0,0,1,0-.731l.421-.348a.474.474,0,0,0,.157-.488l-.141-.534a.468.468,0,0,1,.422-.592l.543-.028a.464.464,0,0,0,.408-.3l.194-.516a.463.463,0,0,1,.433-.3.453.453,0,0,1,.251.076l.455.3a.457.457,0,0,0,.5,0l.455-.3a.452.452,0,0,1,.251-.076.462.462,0,0,1,.432.3l.195.516a.461.461,0,0,0,.407.3l.063,0,.48.025a.45.45,0,0,1,.175.045.474.474,0,0,1,.247.546l-.142.534a.476.476,0,0,0,.155.488l.423.348a.475.475,0,0,1,0,.731l-.423.348a.476.476,0,0,0-.155.488l.142.534a.47.47,0,0,1-.359.584l1.144,2.223a.3.3,0,0,1-.031.324.288.288,0,0,1-.3.1l-.734-.21-.247.734a.291.291,0,0,1-.253.2h-.022a.291.291,0,0,1-.258-.159l-1.067-2.076a.463.463,0,0,1-.118-.056l-.222-.147-.189-.126-.043-.029a.461.461,0,0,0-.173-.069.487.487,0,0,0-.079-.007.455.455,0,0,0-.166.031.475.475,0,0,0-.087.045l-.155.1-.19.126-.11.073-.039.023-1.14,2.219a.29.29,0,0,1-.258.158Zm-.037-1.39.116.348.755-1.473a.5.5,0,0,1-.059-.11l-.194-.517-.008-.021h0a.858.858,0,0,1-.087-.134.47.47,0,0,0-.14-.1.451.451,0,0,0-.085-.03l-1,1.949.347-.1a.278.278,0,0,1,.079-.011A.292.292,0,0,1,10.139,23.778ZM14.2,21.751a.452.452,0,0,0-.1.049.415.415,0,0,0-.047.036.858.858,0,0,1-.105.129.437.437,0,0,0-.027.06l-.195.517a.565.565,0,0,1-.024.054l.727,1.419.117-.348a.29.29,0,0,1,.354-.19l.347.1-.949-1.851A.454.454,0,0,0,14.2,21.751ZM10,19.37a2.4,2.4,0,0,0,.389,1.314,2.373,2.373,0,0,0,.707.7,2.3,2.3,0,0,0,2.548-.035,2.393,2.393,0,0,0,1.042-1.982,2.343,2.343,0,1,0-4.686,0ZM.5,21.354a.507.507,0,0,1-.5-.51V.51A.507.507,0,0,1,.5,0H14.786a.507.507,0,0,1,.5.51V16.7l-.194-.071a.494.494,0,0,0-.142-.029l-.666-.035V1.021H1V20.334H9.166l-.179.68a.5.5,0,0,0-.015.179l.015.162Zm11.487-.939h0a.292.292,0,0,1-.21-.089l-.748-.761a.309.309,0,0,1,0-.432.3.3,0,0,1,.424,0l.537.546,1.241-1.264a.3.3,0,0,1,.425,0,.309.309,0,0,1,0,.432L12.2,20.325a.3.3,0,0,1-.212.09ZM2.936,13.754a.51.51,0,0,1,0-1.021H9.595a.51.51,0,0,1,0,1.021Zm0-3.024a.51.51,0,0,1,0-1.021h9.415a.51.51,0,0,1,0,1.021Zm0-3.024a.51.51,0,0,1,0-1.021h9.415a.51.51,0,0,1,0,1.021Zm0-3.024a.51.51,0,0,1,0-1.021h9.415a.51.51,0,0,1,0,1.021Z"
        transform="translate(872.998 -206.621)"
        fill="#fff"
        stroke="rgba(0,0,0,0)"
        strokeMiterlimit="10"
        strokeWidth="1"
      />
    </g>
  </svg>
);

const AddSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="138" height="134" viewBox="0 0 138 134">
    <g opacity="0.22">
      <g fill="#fff" stroke="#707070" strokeWidth="1">
        <rect width="138" height="134" rx="22" stroke="none" />
        <rect x="0.5" y="0.5" width="137" height="133" rx="21.5" fill="none" />
      </g>
      <path
        d="M49,102.5V58H4.5a4.5,4.5,0,0,1,0-9H49V4.5a4.5,4.5,0,0,1,9,0V49h44.5a4.5,4.5,0,0,1,0,9H58v44.5a4.5,4.5,0,0,1-9,0Z"
        transform="translate(16 13)"
        fill="#7c7c7c"
      />
    </g>
  </svg>
);

const DuplicateSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20.875" height="20.875" viewBox="0 0 20.875 20.875">
    <g transform="translate(-1883.125 -197)">
      <path
        d="M109.438,268.322q0-2.733,0-5.466a2.41,2.41,0,0,1,2.535-2.533h10.983a2.409,2.409,0,0,1,2.533,2.535q0,5.492,0,10.983a2.409,2.409,0,0,1-2.535,2.534H111.972a2.411,2.411,0,0,1-2.533-2.535Q109.437,271.081,109.438,268.322Zm7.224-.776c-.551,0-1.067,0-1.584,0a.775.775,0,0,0-.755.483.8.8,0,0,0,.75,1.119c.523.008,1.047,0,1.59,0,0,.537-.02,1.046.01,1.552a1.172,1.172,0,0,0,.215.59.722.722,0,0,0,.862.211.766.766,0,0,0,.515-.732c.01-.532,0-1.064,0-1.621.558,0,1.091.008,1.623,0a.8.8,0,0,0,0-1.6c-.4-.011-.8,0-1.2,0h-.422c0-.531,0-1.024,0-1.516a.807.807,0,1,0-1.6.009C116.661,266.53,116.662,267.022,116.662,267.546Z"
        transform="translate(1773.688 -58.5)"
        fill="#7c7c7c"
      />
      <path
        d="M129.3,243.094a2.425,2.425,0,0,1,.793-2.035,2.328,2.328,0,0,1,1.521-.622c.3-.012.6-.01.9,0a.8.8,0,0,1,0,1.6c-.25.007-.5,0-.752,0a.8.8,0,0,0-.857.867c0,.242,0,.485,0,.727a.8.8,0,1,1-1.6.007C129.294,243.48,129.3,243.321,129.3,243.094Z"
        transform="translate(1758.643 -43.424)"
        fill="#7c7c7c"
      />
      <path
        d="M180.361,240.422a2.442,2.442,0,0,1,1.912.658,2.356,2.356,0,0,1,.757,1.692c.009.284.008.568,0,.852a.8.8,0,1,1-1.6,0c-.006-.259,0-.518,0-.777a.8.8,0,0,0-.828-.82c-.259,0-.518,0-.777,0a.8.8,0,0,1-.009-1.6C179.97,240.418,180.129,240.422,180.361,240.422Z"
        transform="translate(1720.961 -43.415)"
        fill="#7c7c7c"
      />
      <path
        d="M183.032,291.5a2.428,2.428,0,0,1-.829,2.067,2.319,2.319,0,0,1-1.458.589c-.309.015-.619.012-.928,0a.8.8,0,0,1,0-1.6c.267-.008.535,0,.8,0a.8.8,0,0,0,.809-.813c.006-.243,0-.485,0-.727a.805.805,0,1,1,1.6.012C183.033,291.157,183.032,291.291,183.032,291.5Z"
        transform="translate(1720.961 -81.099)"
        fill="#7c7c7c"
      />
      <path
        d="M154.911,240.441c.518,0,1.036,0,1.555,0a.8.8,0,1,1,.009,1.6q-1.554,0-3.109,0a.8.8,0,1,1-.009-1.6C153.874,240.438,154.393,240.441,154.911,240.441Z"
        transform="translate(1741.045 -43.434)"
        fill="#7c7c7c"
      />
      <path
        d="M190.558,266.036c0,.518,0,1.036,0,1.555a.8.8,0,1,1-1.6.009q0-1.555,0-3.109a.8.8,0,1,1,1.6-.009C190.561,265,190.558,265.518,190.558,266.036Z"
        transform="translate(1713.436 -61.014)"
        fill="#7c7c7c"
      />
    </g>
  </svg>
);

const UploadSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="145.236" height="100" viewBox="0 0 145.236 100">
    <g transform="translate(0.5 0.5)">
      <path
        d="M124.213,38.191A31.485,31.485,0,0,1,112.719,99h-81.2a31.573,31.573,0,0,1-2.6-63.034,33.451,33.451,0,0,1-.371-5.562,30.251,30.251,0,0,1,57.1-14.09,25.451,25.451,0,0,1,25.955,2.225,30.989,30.989,0,0,1,12.607,19.652"
        transform="translate(0 0)"
        fill="#7c7c7c"
        stroke="#7c7c7c"
        strokeWidth="1"
      />
      <path
        d="M22,56.319V20.82L9.389,33.431a5.5,5.5,0,0,1-7.778-7.778L25.653,1.611a5.5,5.5,0,0,1,7.778,0L57.472,25.653a5.5,5.5,0,0,1-7.779,7.778L38,21.736V56.319a8,8,0,1,1-16,0Z"
        transform="translate(42.576 26.839)"
        fill="#2c2c2c"
      />
    </g>
  </svg>
);

const ThumbnailSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="134" height="84" viewBox="0 0 134 84">
    <rect width="134" height="84" rx="7.834" fill="#7c7c7c" />
    <g transform="translate(37.025 17.153)">
      <path
        d="M260.215,207.55,244.951,176.82a1.708,1.708,0,0,0-2.95-.2l-20.912,30.728a1.739,1.739,0,0,0,1.415,2.723H258.68A1.736,1.736,0,0,0,260.215,207.55Z"
        transform="translate(-200.45 -163.251)"
        fill="#2c2c2c"
      />
      <path
        d="M242.362,207.523l-14.9-24.939a1.847,1.847,0,0,0-2.879-.166L204.17,207.358c-.765.936.031,2.209,1.381,2.209h35.312C242.112,209.567,242.922,208.461,242.362,207.523Z"
        transform="translate(-201.663 -162.751)"
        fill="#2c2c2c"
      />
      <ellipse cx="7.128" cy="7.21" rx="7.128" ry="7.21" transform="translate(0 0)" fill="#2c2c2c" />
    </g>
  </svg>
);

const HomeThumbnailSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="170" height="140" viewBox="0 0 134 84">
    <rect width="134" height="84" rx="7.834" fill="#7c7c7c" />
    <g transform="translate(37.025 17.153)">
      <path
        d="M260.215,207.55,244.951,176.82a1.708,1.708,0,0,0-2.95-.2l-20.912,30.728a1.739,1.739,0,0,0,1.415,2.723H258.68A1.736,1.736,0,0,0,260.215,207.55Z"
        transform="translate(-200.45 -163.251)"
        fill="#2c2c2c"
      />
      <path
        d="M242.362,207.523l-14.9-24.939a1.847,1.847,0,0,0-2.879-.166L204.17,207.358c-.765.936.031,2.209,1.381,2.209h35.312C242.112,209.567,242.922,208.461,242.362,207.523Z"
        transform="translate(-201.663 -162.751)"
        fill="#2c2c2c"
      />
      <ellipse cx="7.128" cy="7.21" rx="7.128" ry="7.21" transform="translate(0 0)" fill="#2c2c2c" />
    </g>
  </svg>
);

const LiveIconSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="12" viewBox="0 0 24 12">
    <g transform="translate(20402 -6336)">
      <rect width="24" height="12" rx="3" transform="translate(-20402 6336)" fill="#7c7c7c" />
      <text transform="translate(-20386 6344)" fill="#fff" font-size="5" font-family="Rubik-Regular, Rubik">
        <tspan x="-5.242" y="0">
          LIVE
        </tspan>
      </text>
      <g transform="translate(-20400 6338)" fill="none" stroke="#656565" stroke-width="0.4">
        <circle cx="4" cy="4" r="4" stroke="none" />
        <circle cx="4" cy="4" r="3.8" fill="none" />
      </g>
      <g transform="translate(-20399 6339)" fill="#e6e7e8" stroke="#707070" stroke-width="1">
        <circle cx="3" cy="3" r="3" stroke="none" />
        <circle cx="3" cy="3" r="2.5" fill="none" />
      </g>
    </g>
  </svg>
);

const PdfIconSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14.713" height="17.777" viewBox="0 0 14.713 17.777">
    <g transform="translate(-1828.924 -256.578)">
      <path
        d="M1843.637,263.213v9.746a1.373,1.373,0,0,1-1.349,1.4h-12.016a1.373,1.373,0,0,1-1.349-1.4V257.975a1.373,1.373,0,0,1,1.349-1.4h6.958Z"
        fill="#7c7c7c"
      />
      <path d="M1843.637,263.362v.94h-14.713v-6.3a1.39,1.39,0,0,1,1.349-1.428h6.958Z" fill="#7c7c7c" />
      <g transform="translate(1830.322 265.701)">
        <rect width="11.917" height="0.893" rx="0.446" transform="translate(0 0)" fill="#e6e7e8" />
        <rect width="11.917" height="0.893" rx="0.446" transform="translate(0 1.691)" fill="#e6e7e8" />
        <rect width="11.917" height="0.893" rx="0.446" transform="translate(0 3.381)" fill="#e6e7e8" />
        <rect width="11.917" height="0.893" rx="0.446" transform="translate(0 5.072)" fill="#e6e7e8" />
        <rect width="11.917" height="0.893" rx="0.446" transform="translate(0 6.762)" fill="#e6e7e8" />
      </g>
      <path
        d="M2021.269,263.362l-4.843-.053a1.889,1.889,0,0,1-1.889-1.889l.325-4.842Z"
        transform="translate(-177.632)"
        opacity="0.15"
      />
      <path
        d="M2028.5,263.362l-4.609-.378a1.8,1.8,0,0,1-1.8-1.8v-4.608Z"
        transform="translate(-184.865)"
        fill="#7c7c7c"
      />
      <g transform="translate(1830.128 258.932)">
        <path d="M1856.93,363.929h.338v.389h-.338Z" transform="translate(-1856.93 -361.666)" fill="#fff" />
        <path
          d="M1875.806,326.054h.294v.242h.007a.447.447,0,0,1,.426-.294c.466,0,.643.415.643,1,0,.448-.132,1.073-.643,1.073a.446.446,0,0,1-.411-.275h-.007v.871h-.308Zm.687,1.756c.286,0,.36-.3.36-.808,0-.433-.073-.735-.36-.735-.342,0-.4.323-.4.771C1876.1,327.421,1876.162,327.81,1876.493,327.81Z"
          transform="translate(-1874.994 -325.371)"
          fill="#fff"
        />
        <path
          d="M1915.015,314.618h-.294v-.242h-.007a.446.446,0,0,1-.426.294c-.466,0-.643-.415-.643-1.036,0-.411.066-1.036.621-1.036a.478.478,0,0,1,.433.276h.007v-.878h.309Zm-.687-.213c.342,0,.4-.323.4-.771,0-.382-.066-.771-.4-.771-.286,0-.36.3-.36.771S1914.042,314.4,1914.328,314.4Z"
          transform="translate(-1911.206 -311.966)"
          fill="#fff"
        />
        <path
          d="M1950.66,312.237h-.286v-.242h.286v-.231c0-.3.129-.452.426-.452h.224v.264h-.143c-.132,0-.2.051-.2.187v.231h.338v.242h-.338v1.726h-.308Z"
          transform="translate(-1946.355 -311.311)"
          fill="#fff"
        />
      </g>
    </g>
  </svg>
);

const PptIconSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14.798" height="17.874" viewBox="0 0 14.798 17.874">
    <g transform="translate(-2336.009 -2084.803)">
      <path
        d="M2350.806,2091.474v9.8a1.381,1.381,0,0,1-1.356,1.4h-12.085a1.381,1.381,0,0,1-1.356-1.4v-15.065a1.381,1.381,0,0,1,1.356-1.4h7Z"
        fill="#7c7c7c"
      />
      <path d="M2350.806,2091.626v.946h-14.8v-6.332a1.4,1.4,0,0,1,1.356-1.437h7Z" fill="#7c7c7c" />
      <g transform="translate(2337.415 2093.979)">
        <rect width="11.986" height="0.898" rx="0.449" transform="translate(0 0)" fill="#e6e7e8" />
        <rect width="11.986" height="0.898" rx="0.449" transform="translate(0 1.7)" fill="#e6e7e8" />
        <rect width="11.986" height="0.898" rx="0.449" transform="translate(0 3.4)" fill="#e6e7e8" />
        <rect width="11.986" height="0.898" rx="0.449" transform="translate(0 5.101)" fill="#e6e7e8" />
        <rect width="11.986" height="0.898" rx="0.449" transform="translate(0 6.801)" fill="#e6e7e8" />
      </g>
      <path
        d="M2528.393,2091.626l-4.87-.053a1.9,1.9,0,0,1-1.9-1.9l.327-4.87Z"
        transform="translate(-177.587)"
        opacity="0.15"
      />
      <path
        d="M2535.623,2091.626l-4.635-.38a1.808,1.808,0,0,1-1.808-1.808V2084.8Z"
        transform="translate(-184.817)"
        fill="#7c7c7c"
      />
      <g transform="translate(2337.226 2087.261)">
        <path d="M2364.158,2191.692h.34v.392h-.34Z" transform="translate(-2364.158 -2189.527)" fill="#fff" />
        <path
          d="M2383.035,2153.816h.3v.244h.007a.45.45,0,0,1,.429-.3c.469,0,.646.417.646,1,0,.45-.133,1.079-.646,1.079a.449.449,0,0,1-.414-.277h-.008v.875h-.31Zm.691,1.766c.288,0,.362-.3.362-.812,0-.436-.074-.739-.362-.739-.344,0-.4.325-.4.776C2383.327,2155.191,2383.393,2155.582,2383.726,2155.582Z"
          transform="translate(-2382.219 -2153.24)"
          fill="#fff"
        />
        <path
          d="M2422.582,2153.816h.3v.244h.008a.448.448,0,0,1,.428-.3c.469,0,.646.417.646,1,0,.45-.133,1.079-.646,1.079a.449.449,0,0,1-.414-.277h-.008v.875h-.31Zm.691,1.766c.288,0,.362-.3.362-.812,0-.436-.074-.739-.362-.739-.344,0-.4.325-.4.776C2422.874,2155.191,2422.94,2155.582,2423.273,2155.582Z"
          transform="translate(-2420.055 -2153.24)"
          fill="#fff"
        />
        <path
          d="M2457.89,2141.636h.311v.576h.344v.244h-.344v1.271c0,.159.041.222.2.222a.96.96,0,0,0,.137-.011v.255a1.312,1.312,0,0,1-.251.022c-.321,0-.4-.133-.4-.392v-1.367h-.288v-.244h.288Z"
          transform="translate(-2453.561 -2141.636)"
          fill="#fff"
        />
      </g>
    </g>
  </svg>
);

const QuizIconSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="13.199" height="17.777" viewBox="0 0 13.199 17.777">
    <g transform="translate(-1039.602 -0.308)">
      <g transform="translate(1046.875 11.968)">
        <g transform="translate(0 1.331)">
          <path
            d="M2007.231,1731.508a.326.326,0,0,1-.3-.462l1.322-2.867a.324.324,0,0,1,.291-.189h0a.325.325,0,0,1,.292.182l1.41,2.867a.325.325,0,1,1-.584.287l-1.109-2.254-1.035,2.246A.325.325,0,0,1,2007.231,1731.508Z"
            transform="translate(-2006.905 -1727.99)"
            fill="#bebebe"
            fillRule="evenodd"
          />
        </g>
        <g transform="translate(0.296 3.558)">
          <path
            d="M2050.682,2039.04h-2.118a.325.325,0,1,1,0-.651h2.118a.325.325,0,1,1,0,.651Z"
            transform="translate(-2048.238 -2038.389)"
            fill="#bebebe"
            fillRule="evenodd"
          />
        </g>
        <g transform="translate(2.192)">
          <g transform="translate(0.727)">
            <path
              d="M2414.166,1544.446a.326.326,0,0,1-.325-.326v-1.453a.325.325,0,1,1,.65,0v1.453A.325.325,0,0,1,2414.166,1544.446Z"
              transform="translate(-2413.84 -1542.342)"
              fill="#bebebe"
              fillRule="evenodd"
            />
          </g>
          <g transform="translate(0 0.727)">
            <path
              d="M2314.292,1644.32h-1.453a.325.325,0,0,1,0-.651h1.453a.325.325,0,1,1,0,.651Z"
              transform="translate(-2312.513 -1643.669)"
              fill="#bebebe"
              fillRule="evenodd"
            />
          </g>
        </g>
      </g>
      <g transform="translate(1039.602 0.308)">
        <path
          d="M1052.38,18.085h-12.355a.425.425,0,0,1-.423-.427V.734a.425.425,0,0,1,.423-.426h12.355a.425.425,0,0,1,.423.426V17.658a.425.425,0,0,1-.423.427Zm-12.11-.674h11.864V.982H1040.27Z"
          transform="translate(-1039.602 -0.308)"
          fill="#bebebe"
          fillRule="evenodd"
        />
      </g>
      <g transform="translate(1041.393 2.098)">
        <g transform="translate(0)">
          <path
            d="M1291.012,252.029H1289.6a.326.326,0,0,1-.326-.325v-1.415a.326.326,0,0,1,.326-.325h1.415a.325.325,0,0,1,.325.325V251.7a.326.326,0,0,1-.325.325Zm-1.09-.651h.764v-.764h-.764Z"
            transform="translate(-1289.271 -249.963)"
            fill="#bebebe"
            fillRule="evenodd"
          />
        </g>
        <g transform="translate(3.541 0.708)">
          <path
            d="M1742.2,349.278h-5.681a.325.325,0,1,1,0-.651h5.681a.325.325,0,1,1,0,.651Z"
            transform="translate(-1736.193 -348.627)"
            fill="#bebebe"
            fillRule="evenodd"
          />
        </g>
      </g>
      <g transform="translate(1041.393 5.668)">
        <g transform="translate(0)">
          <path
            d="M1291.012,721.127H1289.6a.326.326,0,0,1-.326-.325v-1.415a.326.326,0,0,1,.326-.325h1.415a.325.325,0,0,1,.325.326V720.8a.326.326,0,0,1-.325.325Zm-1.09-.651h.764v-.764h-.764Z"
            transform="translate(-1289.271 -719.061)"
            fill="#bebebe"
            fillRule="evenodd"
          />
        </g>
        <g transform="translate(3.541 0.707)">
          <path
            d="M1742.2,818.346h-5.681a.326.326,0,1,1,0-.651h5.681a.326.326,0,0,1,0,.651Z"
            transform="translate(-1736.193 -817.695)"
            fill="#bebebe"
            fillRule="evenodd"
          />
        </g>
      </g>
      <g transform="translate(1041.393 9.166)">
        <g transform="translate(0)">
          <path
            d="M1291.012,1190.226H1289.6a.326.326,0,0,1-.326-.325v-1.415a.326.326,0,0,1,.326-.326h1.415a.326.326,0,0,1,.325.326v1.415a.326.326,0,0,1-.325.325Zm-1.09-.651h.764v-.764h-.764Z"
            transform="translate(-1289.271 -1188.16)"
            fill="#bebebe"
            fillRule="evenodd"
          />
        </g>
        <g transform="translate(3.541 0.708)">
          <path
            d="M1742.2,1287.491h-5.681a.325.325,0,1,1,0-.651h5.681a.325.325,0,1,1,0,.651Z"
            transform="translate(-1736.193 -1286.84)"
            fill="#bebebe"
            fillRule="evenodd"
          />
        </g>
      </g>
    </g>
  </svg>
);

const VideoIconSVG = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20.875" height="17.778" viewBox="0 0 20.875 17.778">
    <g transform="translate(-1196.872 -273.323)">
      <path
        d="M1647.717,530.673c1.069-.7,5.9-4.809,5.9-1.46v6.12c0,3.349-4.834-.756-5.9-1.46Z"
        transform="translate(-435.873 -246.137)"
        fill="#7c7c7c"
        fillRule="evenodd"
      />
      <path
        d="M1240.978,328.949a2.582,2.582,0,1,0,2.58,2.584,2.582,2.582,0,0,0-2.58-2.584Z"
        transform="translate(-40.147 -53.779)"
        fill="#7c7c7c"
        fillRule="evenodd"
      />
      <path
        d="M1240.225,328.226a2.555,2.555,0,1,0,2.555,2.554,2.556,2.556,0,0,0-2.555-2.554Zm0,5.161a2.608,2.608,0,1,1,2.606-2.606,2.609,2.609,0,0,1-2.606,2.606Z"
        transform="translate(-39.394 -53.027)"
        fill="#7c7c7c"
      />
      <path
        d="M1199.123,509.637h10.99a2.259,2.259,0,0,1,2.251,2.251v5.429a2.259,2.259,0,0,1-2.251,2.251h-10.99a2.259,2.259,0,0,1-2.251-2.251v-5.429a2.259,2.259,0,0,1,2.251-2.251Z"
        transform="translate(0 -228.467)"
        fill="#7c7c7c"
        fillRule="evenodd"
      />
      <path
        d="M1432.69,274.1a3.493,3.493,0,1,0,3.491,3.491,3.491,3.491,0,0,0-3.491-3.491Z"
        transform="translate(-224.612 -0.752)"
        fill="#7c7c7c"
        fillRule="evenodd"
      />
      <path
        d="M1431.844,273.375a3.467,3.467,0,1,0,3.465,3.465,3.47,3.47,0,0,0-3.465-3.465Zm0,6.985a3.519,3.519,0,1,1,3.517-3.52,3.524,3.524,0,0,1-3.517,3.52Z"
        transform="translate(-223.766)"
        fill="#7c7c7c"
      />
      <path
        d="M1264.483,353.359a1.771,1.771,0,1,0,1.773,1.773,1.772,1.772,0,0,0-1.773-1.773Z"
        transform="translate(-63.652 -77.378)"
        fill="#7c7c7c"
        fillRule="evenodd"
      />
    </g>
  </svg>
);

const FilterSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" viewBox="0 0 16 14">
    <path
      id="Icon"
      d="M271,329h-1a1,1,0,0,1,0-2h1a1,1,0,0,1,0,2Zm0-5h-7.28a2,2,0,1,1,0-2H271a1,1,0,0,1,0,2Zm-13,0h-1a1,1,0,0,1,0-2h1a1,1,0,0,1,0,2Zm-1,3h7.28a2,2,0,1,1,0,2H257a1,1,0,0,1,0-2Zm0,5h1a1,1,0,0,1,0,2h-1a1,1,0,0,1,0-2Zm6.72,0H271a1,1,0,0,1,0,2h-7.28a2,2,0,1,1,0-2Z"
      transform="translate(-256 -321)"
      fill="#fff"
      fill-rule="evenodd"
    />
  </svg>
);

export const LppaAdminIcon = (props) => <Icon component={LppaAdminImg} {...props} />;
export const LppaIcon = (props) => <Icon component={LppaImg} {...props} />;

export const SearchIcon = (props) => <Icon component={SearchSVG} {...props} />;
export const DashboardIcon2 = (props) => <Icon component={DashboardSvg2} {...props} />;
export const OverviewIcon = (props) => <Icon component={OverviewIconSvg} {...props} />; // not used
export const ApplicationsIcon = (props) => <Icon component={ApplicationsSvg} {...props} />;
export const ReportsIcon = (props) => <Icon component={ReportsSvg} {...props} />; // not used
export const SettingsIcon = (props) => <Icon component={SettingsSvg} {...props} />; // not used
export const BellIcon = (props) => <Icon component={BellSVG} {...props} />;

export const FacultyIcon = (props) => <Icon component={FacultySVG} {...props} />;
export const FormsIcon = (props) => <Icon component={FormsSVG} {...props} />;
export const LetterIcon = (props) => <Icon component={LetterSVG} {...props} />;
export const ModuleIcon = (props) => <Icon component={ModuleSVG} {...props} />;
export const ShortCourseIcon = (props) => <Icon component={ShortCoursSVG} {...props} />;
export const AddIcon = (props) => <Icon component={AddSvg} {...props} />;
export const DuplicateIcon = (props) => <Icon component={DuplicateSVG} {...props} />;
export const UploadIcon = (props) => <Icon component={UploadSVG} {...props} />;
export const ThumbnailIcon = (props) => <Icon component={ThumbnailSVG} {...props} />;
export const HomeThumbnailIcon = (props) => <Icon component={HomeThumbnailSVG} {...props} />;
export const LiveIcon = (props) => <Icon component={LiveIconSVG} {...props} />;
export const PdfIcon = (props) => <Icon component={PdfIconSVG} {...props} />;
export const PptIcon = (props) => <Icon component={PptIconSVG} {...props} />;
export const QuizIcon = (props) => <Icon component={QuizIconSVG} {...props} />;
export const VideoIcon = (props) => <Icon component={VideoIconSVG} {...props} />;
export const FilterIcon = (props) => <Icon component={FilterSvg} {...props} />;

export { default as RequestIcon } from './RequestIcon';
export { default as ProgrammeIcon } from './ProgrammeIcon';
export { default as ProgramIcon } from './ProgramIcon';
export { default as CalendarIcon } from './CalendarIcon';
export { default as WarningIcon } from './WarningIcon';
export { default as DocumentIcon } from './DocumentIcon';
export { default as DollerIcon } from './DollerIcon';
export { default as StudentsIcon } from './StudentsIcon';
export { default as TickIcon } from './TickIcon';
export { default as DownloadIcon } from './DownloadIcon';
export { default as ChatUpdateIcon } from './ChatUpdateIcon';
export { default as RegistrationVisaIcon } from './RegistrationVisaIcon';
export { default as HomeIcon } from './HomeIcon';
export { default as PhoneIcon } from './PhoneIcon';
export { default as MailIcon } from './MailIcon';
export { default as ScholarshipIcon } from './ScholarshipIcon';
export { default as IncentiveIcon } from './IncentiveIcon';
export { default as UploadStatusIcon } from './UploadStatusIcon';
export { default as UploadRemainIcon } from './UploadRemainIcon';

export { default as ListIcon } from './ListIcon';
export { default as ValueIcon } from './ValueIcon';
export { default as MatrixIcon } from './MatrixIcon';
export { default as LineChartIcon } from './LineChartIcon';
export { default as BarIcon } from './BarIcon';
export { default as PieIcon } from './PieIcon';
export { default as UserIcon } from './UserIcon';
export { default as ClockIcon } from './ClockIcon';
export { default as SetupIcon } from './SetupIcon';
export { default as MaterialsIcon } from './MaterialsIcon';
export { default as PublicationsIcon } from './PublicationsIcon';
export { default as GrantsIcon } from './GrantsIcon';
export { default as ClassroomIcon } from './ClassroomIcon';
export { default as TransactionIcon } from './TransactionIcon';
export { default as RequestTime } from './RequestTime';

// hrms icon

export { default as PolicyIcon } from './PolicyIcon';
export { default as TaskIcon } from './TaskIcon';
export { default as AdvancementIcon } from './AdvancementIcon';
export { default as CircleIcon } from './CircleIcon';
export { default as StaffIcon } from './StaffIcon';
export { default as LogOutIcon } from './LogOutIcon';
export { default as ChangePasswordIcon } from './ChangePasswordIcon';
export { default as PendingIcon } from './PendingIcon';
export { default as UploadDoneIcon } from './UploadDoneIcon';
// export { default as LppaAdminIcon } from './LppaAdminIcon';
// export { default as LppaIcon } from './LppaIcon';
export { default as CatalogueIcon } from './CatalogueIcon';
export { default as DefaultCurrencyIcon } from './DefaultCurrencyIcon';
export { default as PlusIcon } from './PlusIcon';
export { default as ChatInputIcon } from './ChatInputIcon';
export { default as ArchiveIcon } from './ArchiveIcon';
export { default as ContactIcon } from './ContactIcon';
export { default as UploadCloudIcon } from './UploadCloudIcon';